import { useState } from 'react';
import { api } from '../api.js';
import { t } from '../i18n.js';

/**
 * Een persoonsgegeven, standaard gemaskeerd (AVG, docs/besluiten/avg-maskeren.md). De server stuurt `{ m }` (gemaskeerd,
 * geen oogje), `{ m, t }` (gemaskeerd; het oogje haalt de echte waarde op, met een logregel) of `{ m, open }` (de echte
 * waarde, voor een klant die zijn eigen gegevens ziet). `null` wordt een streepje.
 */
export default function Gemaskeerd({ veld, mono = false }) {
  const [echt, zetEcht] = useState(null);
  const [bezig, zetBezig] = useState(false);
  if (veld == null) return <span className="muted">—</span>;
  const kl = mono ? 'mono' : undefined;
  const toon = async () => { zetBezig(true); try { zetEcht((await api.onthul(veld.t)).data.value); } catch { /* laat gemaskeerd */ } finally { zetBezig(false); } };
  return (
    <span className={kl}>
      {echt ?? veld.m}
      {veld.t && echt == null && (
        <button type="button" className="oogje" onClick={toon} disabled={bezig}
          title={t('Tonen (komt in het logboek)')} aria-label={t('Persoonsgegeven tonen')}>
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7Z" fill="none" stroke="currentColor" strokeWidth="1.8" />
            <circle cx="12" cy="12" r="2.6" fill="currentColor" /></svg>
        </button>
      )}
    </span>
  );
}
